import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { Reveal } from '@/components/anim'
import type { BlogPost } from '@/lib/db/posts'

interface BlogSectionProps {
    posts: BlogPost[]
}

export const BlogSection: FC<BlogSectionProps> = ({ posts = [] }): ReactNode => {
    return (
        <div id='blog' className='section'>
            <div className='container'>
                <div className='text-holder'>
                    <Reveal as='h2' className='hero-text'>
                        What we got <span className='gradient-text _02'>to say</span>
                    </Reveal>
                    <div className='fixed-text grey-text'>
                        Empower your users by building cards, accounts, payments, and lending products —
                        as easy as plug-and-play.
                    </div>
                </div>

                <div className='blog-wrapper w-dyn-list'>
                    <div role='list' className='blog-grid w-dyn-items'>
                        {posts.map((post) => (
                            <div role='listitem' className='blog-item w-dyn-item' key={post.slug}>
                                <Link href={`/post/${post.slug}`} className='blog-item-link w-inline-block'>
                                    <div className='blog-item-image-holder'>
                                        <img
                                            src={post.thumbnail}
                                            loading='lazy'
                                            alt={post.title}
                                            className='blog-item-image'
                                        />
                                    </div>
                                    <div className='blog-item-content'>
                                        <h2 className='blog-item-title'>{post.title}</h2>
                                        <p className='blog-item-summary'>{post.summary}</p>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
